import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useIsMobile from '../../hooks/useIsMobile';

const Pagination = ({ totalData, dataPerPage, onChange }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(totalData / dataPerPage);
  const isMobile = useIsMobile();

  useEffect(() => {
    // if (currentPage > totalPages) {
    //   setCurrentPage(totalPages);
    // }
  }, []);

  const handlePageChange = (e, pageNumber) => {
    e.preventDefault();
    if (pageNumber !== currentPage) {
      setCurrentPage(pageNumber);
      onChange(pageNumber);
    }
  };

  const renderPageNumbers = () => {
    if (isMobile) {
      return (
        <li className="page-item active">
          <span className="page-link">{currentPage}</span>
        </li>
      );
    }

    const pages = [];
    const range = 2;
    const startPage = Math.max(1, currentPage - range);
    const endPage = Math.min(totalPages, currentPage + range);

    if (startPage > 1) {
      pages.push(
        <li key={1} className="page-item">
          <Link to="#" className="page-link" onClick={(e) => handlePageChange(e, 1)}>1</Link>
        </li>
      );
      if (startPage > 2) {
        pages.push(<li key="start-ellipsis" className="page-item disabled"><span className="page-link">...</span></li>);
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li key={i} className={`page-item ${currentPage === i ? 'active' : ''}`}>
          <Link to="#" className="page-link" onClick={(e) => handlePageChange(e, i)}>{i}</Link>
        </li>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push(<li key="end-ellipsis" className="page-item disabled"><span className="page-link">...</span></li>);
      }
      pages.push(
        <li key={totalPages} className="page-item">
          <Link to="#" className="page-link" onClick={(e) => handlePageChange(e, totalPages)}>{totalPages}</Link>
        </li>
      );
    }

    return pages;
  };

  return (
    <div className="table-pagination teach mt-3" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <small className="text-muted">
        Showing <span>{(currentPage - 1) * dataPerPage + 1}-{Math.min(currentPage * dataPerPage, totalData)}</span> from <span>{totalData}</span> data
      </small>

      <nav>
        <ul className="pagination pagination-gutter pagination-primary no-bg mb-0 gap-1 text-sm sm:text-base">
          {/* Prev */}
          <li className={`page-item page-indicator ${currentPage === 1 ? 'disabled' : ''}`}>
            <Link to="#" className="page-link" onClick={(e) => currentPage > 1 && handlePageChange(e, currentPage - 1)}>
              <i className="fa-solid fa-chevron-left"></i>
            </Link>
          </li>

          {renderPageNumbers()}

          {/* Next */}
          <li className={`page-item page-indicator ${currentPage === totalPages ? 'disabled' : ''}`}>
            <Link to="#" className="page-link" onClick={(e) => currentPage < totalPages && handlePageChange(e, currentPage + 1)}>
              <i className="fa-solid fa-chevron-right"></i>
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;
